module.exports = function(customizeForm){


    var rawFormArray = customizeForm.serializeArray();
    var prettyFormData = [];

    var jsonForm = customizeForm.serializeFormJSON();
    var jsonMonogram = jsonForm.Monogram ? JSON.parse( jsonForm.Monogram ) : false;

    // var customizationOptions = [
    //     {
    //         "Id": 1,
    //         "Name": "Jacket Fit",
    //         "DisplayName": "Fit",
    //         "Type": 1,
    //         "CustomizationGroupId": 1
    //     },
    //     {
    //         "Id": 2,
    //         "Name": "Jacket Buttons",
    //         "DisplayName": "Buttons",
    //         "Type": 1,
    //         "CustomizationGroupId": 1
    //     },
    //     {
    //         "Id": 3,
    //         "Name": "Lapel",
    //         "DisplayName": "Lapel",
    //         "Type": 1,
    //         "CustomizationGroupId": 1
    //     },
    //     {
    //         "Id": 4,
    //         "Name": "Vents",
    //         "DisplayName": "Vents",
    //         "Type": 1,
    //         "CustomizationGroupId": 1
    //     },
    //     {
    //         "Id": 5,
    //         "Name": "Fabric Lining",
    //         "DisplayName": "Fabric Lining",
    //         "Type": 1,
    //         "CustomizationGroupId": 2
    //     },
    //     {
    //         "Id": 6,
    //         "Name": "Pant Fit",
    //         "DisplayName": "Fit",
    //         "Type": 1,
    //         "CustomizationGroupId": 5
    //     },
    //     {
    //         "Id": 7,
    //         "Name": "Pleats",
    //         "DisplayName": "Pleats",
    //         "Type": 1,
    //         "CustomizationGroupId": 5
    //     },
    //     {
    //         "Id": 8,
    //         "Name": "Cuffs",
    //         "DisplayName": "Cuffs",
    //         "Type": 2,
    //         "CustomizationGroupId": 5
    //     },
    //     {
    //         "Id": 9,
    //         "Name": "Suspender Buttons",
    //         "DisplayName": "Suspender Buttons",
    //         "Type": 2,
    //         "CustomizationGroupId": 5
    //     },
    //     {
    //         "Id": 10,
    //         "Name": "Monogram",
    //         "DisplayName": "Monogram",
    //         "Type": 2,
    //         "CustomizationGroupId": 6
    //     },
    //     {
    //         "Id": 11,
    //         "Name": "Monogram Text",
    //         "DisplayName": "Monogram Text",
    //         "Type": 3,
    //         "CustomizationGroupId": 6
    //     },
    //     {
    //         "Id": 12,
    //         "Name": "Monogram Color",
    //         "DisplayName": "Monogram Color",
    //         "Type": 1,
    //         "CustomizationGroupId": 6
    //     },
    //     {
    //         "Id": 13,
    //         "Name": "Slanted Pockets",
    //         "DisplayName": "Slanted Pockets",
    //         "Type": 2,
    //         "CustomizationGroupId": 7
    //     },
    //     {
    //         "Id": 14,
    //         "Name": "Ticket Pocket",
    //         "DisplayName": "Ticket Pocket",
    //         "Type": 2,
    //         "CustomizationGroupId": 7
    //     },
    //     {
    //         "Id": 15,
    //         "Name": "Boutonniere Hole",
    //         "DisplayName": "Boutonniere Hole",
    //         "Type": 2,
    //         "CustomizationGroupId": 7
    //     },
    //     {
    //         "Id": 16,
    //         "Name": "Functional Buttons",
    //         "DisplayName": "Functional Buttons",
    //         "Type": 2,
    //         "CustomizationGroupId": 7
    //     },
    //     {
    //         "Id": 17,
    //         "Name": "Pick Stitching",
    //         "DisplayName": "Pick Stitching",
    //         "Type": 2,
    //         "CustomizationGroupId": 7
    //     },
    //     {
    //         "Id": 18,
    //         "Name": "Vest Back",
    //         "DisplayName": "Back",
    //         "Type": 1,
    //         "CustomizationGroupId": 3
    //     },
    //     {
    //         "Id": 19,
    //         "Name": "Vest Buttons",
    //         "DisplayName": "Buttons",
    //         "Type": 1,
    //         "CustomizationGroupId": 3
    //     },
    //     {
    //         "Id": 20,
    //         "Name": "Shirt Fit",
    //         "DisplayName": "Fit",
    //         "Type": 1,
    //         "CustomizationGroupId": 4
    //     },
    //     {
    //         "Id": 21,
    //         "Name": "Collar",
    //         "DisplayName": "Collar",
    //         "Type": 1,
    //         "CustomizationGroupId": 4
    //     },
    //     {
    //         "Id": 22,
    //         "Name": "Cuff",
    //         "DisplayName": "Cuff",
    //         "Type": 1,
    //         "CustomizationGroupId": 4
    //     },
    //     {
    //         "Id": 23,
    //         "Name": "Contrast Cuff/Collar",
    //         "DisplayName": "Contrast Cuff/Collar",
    //         "Type": 2,
    //         "CustomizationGroupId": 8
    //     },
    //     {
    //         "Id": 24,
    //         "Name": "Shirt Pocket",
    //         "DisplayName": "Shirt Pocket",
    //         "Type": 2,
    //         "CustomizationGroupId": 8
    //     },
    //     {
    //         "Id": 25,
    //         "Name": "Belt",
    //         "DisplayName": "Belt",
    //         "Type": 2,
    //         "CustomizationGroupId": 9
    //     },
    //     {
    //         "Id": 26,
    //         "Name": "Half Lined",
    //         "DisplayName": "Half Lined",
    //         "Type": 2,
    //         "CustomizationGroupId": 7
    //     },
    //     {
    //         "Id": 27,
    //         "Name": "Jacket Pockets",
    //         "DisplayName": "Pockets",
    //         "Type": 1,
    //         "CustomizationGroupId": 1
    //     },
    //     {
    //         "Id": 28,
    //         "Name": "Besom Pockets",
    //         "DisplayName": "Besom Pockets",
    //         "Type": 1,
    //         "CustomizationGroupId": 14
    //     },
    //     {
    //         "Id": 29,
    //         "Name": "Side Tabs (No Belt Loops)",
    //         "DisplayName": "Side Tabs (No Belt Loops)",
    //         "Type": 1,
    //         "CustomizationGroupId": 14
    //     },
    //     {
    //         "Id": 30,
    //         "Name": "Vest Neck",
    //         "DisplayName": "Neck",
    //         "Type": 1,
    //         "CustomizationGroupId": 3
    //     },
    //     {
    //         "Id": 31,
    //         "Name": "Vest Pockets",
    //         "DisplayName": "Pockets",
    //         "Type": 1,
    //         "CustomizationGroupId": 10
    //     },
    //     {
    //         "Id": 32,
    //         "Name": "Vest Buckle",
    //         "DisplayName": "Buckle",
    //         "Type": 1,
    //         "CustomizationGroupId": 10
    //     },
    //     {
    //         "Id": 33,
    //         "Name": "Vest Pockets - Slanted",
    //         "DisplayName": "Pockets - Slanted",
    //         "Type": 1,
    //         "CustomizationGroupId": 10
    //     },
    //     {
    //         "Id": 34,
    //         "Name": "Overcoat Lapel",
    //         "DisplayName": "Lapel",
    //         "Type": 1,
    //         "CustomizationGroupId": 11
    //     },
    //     {
    //         "Id": 35,
    //         "Name": "Overcoat Buttons",
    //         "DisplayName": "Buttons",
    //         "Type": 1,
    //         "CustomizationGroupId": 11
    //     },
    //     {
    //         "Id": 36,
    //         "Name": "Dress Shirt Placket",
    //         "DisplayName": "Placket",
    //         "Type": 1,
    //         "CustomizationGroupId": 4
    //     },
    //     {
    //         "Id": 37,
    //         "Name": "Monogram Font",
    //         "DisplayName": "Monogram Font",
    //         "Type": 1,
    //         "CustomizationGroupId": 6
    //     },
    //     {
    //         "Id": 38,
    //         "Name": "Short Sleeves",
    //         "DisplayName": "Short Sleeves",
    //         "Type": 2,
    //         "CustomizationGroupId": 8
    //     },
    //     {
    //         "Id": 39,
    //         "Name": "Unstructured",
    //         "DisplayName": "Unstructured",
    //         "Type": 2,
    //         "CustomizationGroupId": 8
    //     },
    //     {
    //         "Id": 40,
    //         "Name": "Casual Shirt Collar",
    //         "DisplayName": "Collar",
    //         "Type": 1,
    //         "CustomizationGroupId": 12
    //     },
    //     {
    //         "Id": 41,
    //         "Name": "Casual Shirt Cuff",
    //         "DisplayName": "Cuff",
    //         "Type": 1,
    //         "CustomizationGroupId": 12
    //     },
    //     {
    //         "Id": 42,
    //         "Name": "Casual Shirt Placket",
    //         "DisplayName": "Placket",
    //         "Type": 1,
    //         "CustomizationGroupId": 12
    //     },
    //     {
    //         "Id": 43,
    //         "Name": "Casual Shirt Contrast Cuff/Collar",
    //         "DisplayName": "Contrast Cuff/Collar",
    //         "Type": 2,
    //         "CustomizationGroupId": 13
    //     },
    //     {
    //         "Id": 44,
    //         "Name": "Casual Shirt Shirt Pocket",
    //         "DisplayName": "Shirt Pocket",
    //         "Type": 2,
    //         "CustomizationGroupId": 13
    //     },
    //     {
    //         "Id": 45,
    //         "Name": "Casual Shirt Short Sleeves",
    //         "DisplayName": "Short Sleeves",
    //         "Type": 2,
    //         "CustomizationGroupId": 13
    //     },
    //     {
    //         "Id": 46,
    //         "Name": "Casual Shirt Unstructured",
    //         "DisplayName": "Unstructured",
    //         "Type": 2,
    //         "CustomizationGroupId": 13
    //     },
    //     {
    //         "Id": 47,
    //         "Name": "Pant Extra Tapered",
    //         "DisplayName": "Extra Tapered",
    //         "Type": 1,
    //         "CustomizationGroupId": 14
    //     },
    //     {
    //         "Id": 48,
    //         "Name": "Chino Pant Fit",
    //         "DisplayName": "Fit",
    //         "Type": 1,
    //         "CustomizationGroupId": 15
    //     },
    //     {
    //         "Id": 49,
    //         "Name": "Chino Pant Pleats",
    //         "DisplayName": "Pleats",
    //         "Type": 1,
    //         "CustomizationGroupId": 15
    //     },
    //     {
    //         "Id": 50,
    //         "Name": "Chino Pant Cuffs",
    //         "DisplayName": "Cuffs",
    //         "Type": 2,
    //         "CustomizationGroupId": 15
    //     },
    //     {
    //         "Id": 51,
    //         "Name": "Chino Pant Suspender Buttons",
    //         "DisplayName": "Suspender Buttons",
    //         "Type": 2,
    //         "CustomizationGroupId": 15
    //     },
    //     {
    //         "Id": 52,
    //         "Name": "Chino Pant Front Pockets",
    //         "DisplayName": "Front Pockets",
    //         "Type": 2,
    //         "CustomizationGroupId": 15
    //     },
    //     {
    //         "Id": 53,
    //         "Name": "Chino Pant Back Pockets",
    //         "DisplayName": "Back Pockets",
    //         "Type": 2,
    //         "CustomizationGroupId": 15
    //     },
    //     {
    //         "Id": 54,
    //         "Name": "Chino Pant Besom Pockets",
    //         "DisplayName": "Besom Pockets",
    //         "Type": 2,
    //         "CustomizationGroupId": 16
    //     },
    //     {
    //         "Id": 55,
    //         "Name": "Chino Pant Side Tabs (No Belt Loops)",
    //         "DisplayName": "Side Tabs (No Belt Loops)",
    //         "Type": 2,
    //         "CustomizationGroupId": 16
    //     },
    //     {
    //         "Id": 56,
    //         "Name": "Chino Pant Extra Tapered",
    //         "DisplayName": "Extra Tapered",
    //         "Type": 2,
    //         "CustomizationGroupId": 16
    //     },
    //     {
    //         "Id": 57,
    //         "Name": "Tuxedo Jacket Details",
    //         "DisplayName": "Tuxedo Jacket Details",
    //         "Type": 2,
    //         "CustomizationGroupId": 7
    //     },
    //     {
    //         "Id": 58,
    //         "Name": "Satin Waistband",
    //         "DisplayName": "Satin Waistband",
    //         "Type": 2,
    //         "CustomizationGroupId": 5
    //     },
    //     {
    //         "Id": 59,
    //         "Name": "Satin Outseam",
    //         "DisplayName": "Satin Outseam",
    //         "Type": 2,
    //         "CustomizationGroupId": 5
    //     }
    // ];


    if (jsonMonogram && jsonMonogram.Value != 'No' ) {

        // prettyFormData.push( {
        //     CustomizationOptionId: '10',
        //     titleOfStep: 'Monogram',
        //     Value: '59',
        //     valueId: '59',
        //     valueTitle: 'Yes',
        //     valueText: 'Yes',
        // } );

        prettyFormData.push(jsonMonogram); // pushes color

        prettyFormData.push({
            CustomizationOptionId: '11',
            titleOfStep: 'Monogram Text',
            Value: jsonForm.MonogramText,
            valueId: jsonForm.MonogramText,
            valueText: jsonForm.MonogramText,
            valueTitle: jsonForm.MonogramText,
        });


    }



    var joinedFits = jsonForm['1/6'];

    if (false && joinedFits) {
        var joinedFitsJson = JSON.parse(joinedFits);
        var modern = joinedFitsJson.valueId == 1 ||  joinedFitsJson.valueId == 23;
        var classic = joinedFitsJson.valueId == 2 ||  joinedFitsJson.valueId == 24;

        if (modern) {

            prettyFormData.push( {
                CustomizationOptionId: '1',
                titleOfStep: 'Jacket Fit',
                Value: '1',
                valueId: '1',
                valueTitle: 'Modern',
                valueText: 'Modern',
            } );

            prettyFormData.push( {
                CustomizationOptionId: '6',
                titleOfStep: 'Pant Fit',
                Value: '23',
                valueId: '23',
                valueTitle: 'Classic',
                valueText: 'Classic',
            } );

        }

        if (classic) {

            prettyFormData.push( {
                CustomizationOptionId: '1',
                titleOfStep: 'Jacket Fit',
                Value: '2',
                valueId: '2',
                valueTitle: 'Classic',
                valueText: 'Classic',
            } );


            prettyFormData.push( {
                CustomizationOptionId: '6',
                titleOfStep: 'Pant Fit',
                Value: '24',
                valueId: '24',
                valueTitle: 'Classic',
                valueText: 'Classic',
            } );

        }

    }


    $(rawFormArray).each(function(i, e) {

        if ( (e.name == 'Monogram') || (e.name == 'MonogramText') ) {

        }

        else if ( e.name == '1/6' ) {

        }

        else if(e.value) {
            prettyFormData.push( JSON.parse( e.value ) );
        }

    });

    //console.dir(prettyFormData);

    return prettyFormData;


}; // end of module.exports




// WEBPACK FOOTER //
// ./js-source/integration/get-customizations.js